import * as React from 'react';
import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'hc:inline-flex hc:items-center hc:justify-center hc:rounded-sm hc:border hc:px-2 hc:py-0.5 hc:text-sm hc:font-semibold hc:w-fit hc:whitespace-nowrap hc:shrink-0 hc:[&>svg]:size-3 hc:gap-1 hc:[&>svg]:pointer-events-none hc:focus-visible:border-ring hc:focus-visible:ring-ring/50 hc:focus-visible:ring-[3px] hc:aria-invalid:ring-destructive/20 hc:dark:aria-invalid:ring-destructive/40 hc:aria-invalid:border-destructive hc:transition-[color,box-shadow] hc:overflow-hidden',
  {
    variants: {
      variant: {
        default:
          'hc:border-transparent hc:bg-buttons-primary-alt hc:text-primary-foreground hc:[a&]:hover:bg-buttons-primary-alt/90',
        secondary:
          'hc:border-[#D8D8D8] hc:dark:border-border hc:bg-[#F4F4F4] hc:dark:bg-muted hc:text-secondary-foreground hc:[a&]:hover:bg-[#F4F4F4]/90',
        destructive:
          'hc:border-transparent hc:bg-destructive hc:text-white hc:[a&]:hover:bg-destructive/90 hc:focus-visible:ring-destructive/20 hc:dark:focus-visible:ring-destructive/40 hc:dark:bg-destructive/60',
        outline: 'hc:text-foreground hc:[a&]:hover:bg-accent hc:[a&]:hover:text-accent-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

function Badge({
  className,
  variant,
  asChild = false,
  ...props
}: React.ComponentProps<'span'> & VariantProps<typeof badgeVariants> & { asChild?: boolean }) {
  const Comp = asChild ? Slot : 'span';

  return (
    <Comp data-slot='badge' className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export { Badge, badgeVariants };
